// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Headlines-H1-module--cls1--2Q_xN","cls2":"Headlines-H1-module--cls2--32h32 Headlines-H1-module--cls1--2Q_xN","portfolio":"Headlines-H1-module--portfolio--3r1z8"};